import React, {  useEffect, useState }  from 'react';
import { get, pick } from 'lodash';
import PropTypes from 'prop-types';
import { Form, Button, Icon, Modal, ExistingFranchiseList, Input, ServiceUnits } from '../components';
import { useModal, useAction, useSelect, useForm, useFormValidator } from '../hooks';
import { random } from 'lodash';
import { SelectRegion, SelectProvince, SelectMunicipality, SelectBarangay } from '../containers';

const initialFormData = {
  number_of_authorized_units: '',
  service_type_id: '',
  garage_dimension: '',
  number_of_units_per_garage: '',
  is_owned: 0,
  is_leased: 0,
  is_others: 0,
  name_of_lessor: '',
  route_id: '',
  route_other: '',
  garage_street: '',
  service_units: [],
  existing_franchises: [],
}

const rules = {
  number_of_authorized_units: 'required|number|maximum:3',
  service_type_id: 'required',
  route_id: 'required_if:is_others=0',
  route_other: 'required_if:is_others=1',
  garage_dimension: 'number',
  number_of_units_per_garage: 'number',
  name_of_lessor: 'required_if:is_leased=1|text_vapt',
  garage_street: 'required',
  service_units: 'required'
}


const serviceUnitsInitialFormData = {
  make: '',
  motor_no: '',
  chassis_no: '',
  plate_no: '',
  conduction_no: '',
  model: ''
}

const serviceUnitsRules = {
  make: 'required|service_type',
  motor_no: 'required|service_type',
  chassis_no: 'required|service_type',
  plate_no: 'required|service_type',
  conduction_no: 'required|service_type',
  model: 'required|service_type'
}

const existingFranchiseInitialFormData = {
  case_number: '',
  number_of_authorized_units: '',
  service_type_id: '',
  garage_location: '',
}


const existingFranchiseRules = {
  case_number: 'required',
  number_of_authorized_units: 'required|number',
  service_type_id: 'required',
  garage_location: 'required',
}


const initFormDataGarageAddress = {
  garage_region_id: '',
  garage_province_id: '',
  garage_municipality_id: '',
  garage_barangay_id: '',
}

const garageAddressRules = {
  garage_region_id: 'required',
  garage_province_id: 'required',
  garage_municipality_id: 'required',
  garage_barangay_id: 'required',
}

export const options = {
  initialFormData: {
    ...initialFormData,
    ...initFormDataGarageAddress
  },
  rules: {
    ...rules,
    ...garageAddressRules
  }
}

const ExistingFranchiseForm = ({  onNext, onPrevious, initialValue, id, method }) => {
  const [existingFranchise, setExistingFranchise] = useState(true)
  const [isOpen, onOpen, onClose] = useModal()
  const [isOpenServiceUnits, onOpenServiceUnits, onCloseServiceUnits] = useModal()

  const [value, { onChange, onChangeWithCallBack, onChangeNumber, onCreateUpdateToList, onDeleteToList, onSetForm, onChangeWithRegExp }] = useForm(initialFormData)
  const { response, onSetObjectRules, renderMessage } = useFormValidator(value, rules, {
    is_leased: {
      'required_if_value': 'YES'
    },
    is_others: {
      'required_if_value': 'none'
    }
  })
  const [garageAddressFormData, garageAddressFormAction] = useForm(initFormDataGarageAddress)
  const garageAddressFormValidator = useFormValidator(garageAddressFormData, garageAddressRules)

  const [formDataExistingFranchise, existringFranchiseAction] = useForm(existingFranchiseInitialFormData)
  const validateExistingFranchise = useFormValidator(formDataExistingFranchise, existingFranchiseRules)

  const [formDataServiceUnits, serviceUnitsAction] = useForm(serviceUnitsInitialFormData)
  const validateServinceUnits = useFormValidator(formDataServiceUnits, serviceUnitsRules)

  const getProfile = useAction('auth.getProfile')
  const profile = useSelect('auth.profile')

  const getServiceUnits = useAction('application.getServiceUnits')
  const serviceUnits = useSelect('application.serviceUnits')

  const serviceTypeGetList = useAction('serviceType.getList');
  const seviceTypeList = useSelect('serviceType.list');
  const serviceTypeListing = useSelect('loading.isLoading', { type: 'serviceType.getList' })

  const serviceTypeOptions = Object.values(seviceTypeList).map(item => {
    return {
      label: get(item, 'attributes.name'),
      value: get(item, 'id')
    }
  })

  const routeGetList = useAction('route.getList');
  const routeList = useSelect('route.list');
  const routeListing = useSelect('loading.isLoading', { type: 'route.getList' })
  const routeOptions = Object.values(routeList).map(item => {
    return {
      label: get(item, 'attributes.name'),
      value: get(item, 'id')
    }
  })

  const combinedPayload = {
    ...value,
    ...garageAddressFormData
  }

  useEffect(() => {
    onSetForm(pick(initialValue, Object.keys(initialFormData)))
    garageAddressFormAction.onSetForm(pick(initialValue, Object.keys(initFormDataGarageAddress)))
    // eslint-disable-next-line
  }, [Object.values(initialValue).join(',')])

  useEffect(() => {
    serviceTypeGetList()
    getProfile()
    if(method === 'update'){
      getServiceUnits(id)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (method === 'update') {
      value.service_units = value.service_units.filter(x => {if (x.cpc_application_id === +id || !x.cpc_application_id) return x;})
    }
  },[id, value.service_units])

  useEffect(() => {
    if (value.service_type_id){
      if (parseInt(value.service_type_id) === 29) {
        setExistingFranchise(false)
      } else {
        setExistingFranchise(true)
      }
      routeGetList({service_type_id: value.service_type_id})
    } else {
      routeGetList({service_type_id: '0'})
    }
  }, [value.service_type_id])

  useEffect(() => {
    if(value.number_of_authorized_units && value.number_of_authorized_units < value.service_units.length){
      value.service_units.pop()
    }
    onSetObjectRules({
      ...rules,
      number_of_authorized_units: `required|number|maximum:${method === 'update' && serviceUnits ? serviceUnits.remaining_service_units : 3 - (get(profile, 'attributes.total_service_units'))}`
    })
  }, [value.number_of_authorized_units])

  const handleSubmitExistingFrachise = e => {
    e.preventDefault()
    onCreateUpdateToList({
      target: {
        name: 'existing_franchises',
        value: {
          id: random(1, 1000),
          ...formDataExistingFranchise
        }
      }
    })
    existringFranchiseAction.onSetForm(existingFranchiseInitialFormData)
    onClose()
  }

  const handleSubmitServiceUnits = e => {
    e.preventDefault()
    onCreateUpdateToList({
      target: {
        name: 'service_units',
        value: {
          id: random(1, 1000),
          ...formDataServiceUnits
        }
      }
    })
    serviceUnitsAction.onSetForm(serviceUnitsInitialFormData)
    onCloseServiceUnits()
  }

  const handleShowModal = e => {
    e.preventDefault()
    onOpen()
  }

  const handleShowServiceUnitsModal = e => {
    e.preventDefault()
    onOpenServiceUnits()
  }

  const handleOnEditItem = data => e => {
    e.preventDefault()
    existringFranchiseAction.onSetForm(data)
    onOpen()
  }

  const handleOnEditServiceUnitsItem = data => e => {
    e.preventDefault()
    serviceUnitsAction.onSetForm(data)
    onOpenServiceUnits()
  }

  const handleOnDeleteItem = data => {
    onDeleteToList({
      target: {
        name: 'existing_franchises',
        value: data
      }
    })
    existringFranchiseAction.onSetForm(existingFranchiseInitialFormData)
    onClose()
  }

  const handleOnDeleteServiceUnitsItem = data => {
    onDeleteToList({
      target: {
        name: 'service_units',
        value: data
      }
    })
    serviceUnitsAction.onSetForm(serviceUnitsInitialFormData)
    onCloseServiceUnits()
  }

  const isFormValidationPassed = response.is_passed && garageAddressFormValidator.response.is_passed

  const isOwnedOnChangeCallback = data => {
    if(data.is_owned){
      onSetForm({
        ...data,
        is_leased: 0
      })
    }
  }

  const isLeasedOnChangeCallback = data => {
    if(data.is_leased){
      onSetForm({
        ...data,
        is_owned: 0
      })
    }
  }

  const routeToggleCallBack = data => {
    onSetForm({
      ...data,
      route_id: '',
      route_other: '',
    })
  }

  return (
    <>
      <Form.FormGroup className="form-group-4">
        <Input
          label={
            <>
              No. of Authorized Units
              {/* {(value.number_of_authorized_units === '' || (value.number_of_authorized_units <= (3 - get(profile, 'attributes.total_service_units')))) &&
                <small
                  className="bg-info text-white px-2 font-light rounded-t rounded-r ml-1"
                >
                  Remaining Units: {3 - (get(profile, 'attributes.total_service_units'))}
                </small>
              } */}
            </>
          }
          name="number_of_authorized_units"
          value={value.number_of_authorized_units}
          onChange={onChangeNumber}
          helperMessage={renderMessage}
        />
        <Input
          isLoading={serviceTypeListing}
          type="select"
          options={serviceTypeOptions}
          label="Type of Service"
          name="service_type_id"
          value={value.service_type_id}
          onChange={onChange}
          helperMessage={renderMessage}
        />
        <Input
          label="Garage Dimension (sqm)"
          name="garage_dimension"
          value={value.garage_dimension}
          onChange={onChangeNumber}
          helperMessage={renderMessage}
        />
        <Input
          label="Number of units per garage"
          name="number_of_units_per_garage"
          value={value.number_of_units_per_garage}
          onChange={onChangeNumber}
          helperMessage={renderMessage}
        />
        <Input
          type="yes_or_no"
          label="Owned ?"
          name="is_owned"
          value={value.is_owned}
          onChange={onChangeWithCallBack(isOwnedOnChangeCallback)}
          helperMessage={renderMessage}
        />
        <Input
          type="yes_or_no"
          label="Leased ?"
          name="is_leased"
          value={value.is_leased}
          onChange={onChangeWithCallBack(isLeasedOnChangeCallback)}
          helperMessage={renderMessage}
        />
        <Input
          disabled={!value.is_leased}
          label="Name of Lessor"
          name="name_of_lessor"
          value={value.name_of_lessor}
          onChange={onChange}
          helperMessage={renderMessage}
        />
      </Form.FormGroup>
      <Form.FormGroup className="form-group-4">
          {/* <div className="w-3/12 flex">
            <Input type="checkbox" label="Other Route ?" name="is_others" value={value.is_others} onChange={onSwitchWithCallBack(routeToggleCallBack)}/>
          </div>  */}
        <Input
          type="yes_or_no"
          label="Other Route ?"
          name="is_others"
          value={value.is_others}
          onChange={onChangeWithCallBack(routeToggleCallBack)}
        />

        <Input
            isLoading={routeListing}
            type="select"
            options={value.is_others ? [] : [...routeOptions]}
            label="Route"
            name="route_id"
            value={value.route_id}
            onChange={onChange}
            helperMessage={renderMessage}
            isDisabled={value.is_others}
        />
        <Input
          label="Other Route"
          name="route_other"
          value={value.is_others ? value.route_other : ''}
          onChange={onChange}
          helperMessage={renderMessage}
          disabled={!value.is_others}
        />
      </Form.FormGroup>
      <span className="text-success text-sm font-bold">Garage Address</span>
      <Form.FormGroup className="form-group-4">
        <SelectRegion
          prefixName="garage_"
          onChange={garageAddressFormAction.onChange}
          value={garageAddressFormData.garage_region_id}
          helperMessage={garageAddressFormValidator.renderMessage}/>
        <SelectProvince
          prefixName="garage_"
          region_id={garageAddressFormData.garage_region_id}
          onChange={garageAddressFormAction.onChange}
          value={garageAddressFormData.garage_province_id}
          helperMessage={garageAddressFormValidator.renderMessage}/>
        <SelectMunicipality
          prefixName="garage_"
          region_id={garageAddressFormData.garage_region_id}
          province_id={garageAddressFormData.garage_province_id}
          onChange={garageAddressFormAction.onChange}
          value={garageAddressFormData.garage_municipality_id}
          helperMessage={garageAddressFormValidator.renderMessage} />
        <SelectBarangay
          prefixName="garage_"
          region_id={garageAddressFormData.garage_region_id}
          province_id={garageAddressFormData.garage_province_id}
          municipality_id={garageAddressFormData.garage_municipality_id}
          onChange={garageAddressFormAction.onChange}
          value={garageAddressFormData.garage_barangay_id}
          helperMessage={garageAddressFormValidator.renderMessage}/>
      </Form.FormGroup>
      <Form.FormGroup className="form-group">
        <Input label="Unit/Room number/Floor, Building Name, House number, Street
                  name." name="garage_street" onChange={onChange} value={value.garage_street} helperMessage={renderMessage}/>
      </Form.FormGroup>
      <div className="my-3">
        <span className="text-success text-sm font-bold ">{get(value, 'number_of_authorized_units') && get(value, 'number_of_authorized_units') <= 3 - get(profile, 'attributes.total_service_units') && get(value, 'number_of_authorized_units') > 0 ? `Input ${value.number_of_authorized_units}` : ''} Service Units</span>
      </div>
      <div className="p-1">
        <ServiceUnits
          data={value.service_units}
          onEditItem={handleOnEditServiceUnitsItem}
          onDeleteItem={handleOnDeleteServiceUnitsItem} />
        {get(value, 'number_of_authorized_units') > get(value, 'service_units.length') && (( get(value, 'number_of_authorized_units') <= 3 - get(profile, 'attributes.total_service_units')) || method === 'update' && serviceUnits.remaining_service_units > get(value, 'service_units.length')) &&  <div className="flex space-x-2 items-center py-5">
          <span className="text-lg font-medium text-red-600">Add Service Units</span>
          {renderMessage('service_units')}
          <Button className="!w-auto !bg-warning !text-black" onClick={handleShowServiceUnitsModal}><Icon.Plus /></Button>
        </div>}
      </div>
      {existingFranchise &&
        <>
          <div className="my-3">
            <span className="text-success text-sm font-bold ">Existing Franchise</span>
          </div>
          <div className="p-1">
            <ExistingFranchiseList
              data={value.existing_franchises}
              onEditItem={handleOnEditItem}
              onDeleteItem={handleOnDeleteItem} />
            <div className="flex space-x-2 items-center py-5">
              <span className="text-sm">Add other existing franchise</span>
              <Button className="!w-auto !bg-warning !text-black" onClick={handleShowModal}><Icon.Plus /></Button>
            </div>
          </div>
        </>
      }
      <div className="flex space-x-2 float-right mt-2">
        <Button type="button" onClick={onPrevious(combinedPayload)} className="!bg-warning !w-auto !text-black">Previous</Button>
        <Button disabled={!isFormValidationPassed || !(parseInt(value.number_of_authorized_units) === value.service_units.length)} type="button" onClick={onNext(combinedPayload)} className="!bg-warning !w-auto !text-black">Next</Button>
      </div>
      <Modal isOpen={isOpen} onClose={onClose}>
        <Form>
          <Form.FormGroup>
            <Input

            regexp='^[a-zA-Z\-\d]*$'
              label="Case Number"
              name="case_number"
              value={formDataExistingFranchise.case_number}
              onChange={existringFranchiseAction.onChangeWithRegExp}
              helperMessage={validateExistingFranchise.renderMessage}
            />
            <Input
              label="No. of Authorized Units"
              name="number_of_authorized_units"
              value={formDataExistingFranchise.number_of_authorized_units}
              onChange={existringFranchiseAction.onChangeNumber}
              helperMessage={validateExistingFranchise.renderMessage}
            />
            <Input
              isLoading={serviceTypeListing}
              type="select"
              options={serviceTypeOptions}
              label="Type of Service"
              name="service_type_id"
              value={formDataExistingFranchise.service_type_id}
              onChange={existringFranchiseAction.onChange}
              helperMessage={validateExistingFranchise.renderMessage}
            />
            <Input
              label="Garage Location"
              name="garage_location"
              value={formDataExistingFranchise.garage_location}
              onChange={existringFranchiseAction.onChange}
              helperMessage={validateExistingFranchise.renderMessage}
            />
          </Form.FormGroup>
          <div>
            <Button
              onClick={handleSubmitExistingFrachise}
              disabled={!validateExistingFranchise.response.is_passed}
              type="button"
              className="!w-auto !bg-warning !text-black float-right">
              {formDataExistingFranchise.id && 'Update'}
              {!formDataExistingFranchise.id && 'Add'}
            </Button>
          </div>
        </Form>
      </Modal>
      <Modal isOpen={isOpenServiceUnits} onClose={onCloseServiceUnits}>
        <Form>
          <Form.FormGroup>
            <Input
              label="Make"
              name="make"
              value={formDataServiceUnits.make}
              onChange={serviceUnitsAction.onChange}
              helperMessage={validateServinceUnits.renderMessage}
            />
            <Input
              label="Motor No."
              name="motor_no"
              value={formDataServiceUnits.motor_no}
              onChange={serviceUnitsAction.onChange}
              helperMessage={validateServinceUnits.renderMessage}
            />
            <Input
              label="Chasis No."
              name="chassis_no"
              value={formDataServiceUnits.chassis_no}
              onChange={serviceUnitsAction.onChange}
              helperMessage={validateServinceUnits.renderMessage}
            />
            <Input
              label="Plate No."
              name="plate_no"
              value={formDataServiceUnits.plate_no}
              onChange={serviceUnitsAction.onChange}
              helperMessage={validateServinceUnits.renderMessage}
            />
            <Input
              label="Conduction No."
              name="conduction_no"
              value={formDataServiceUnits.conduction_no}
              onChange={serviceUnitsAction.onChange}
              helperMessage={validateServinceUnits.renderMessage}
            />
            <Input
              label="Year Model"
              name="model"
              value={formDataServiceUnits.model}
              onChange={serviceUnitsAction.onChange}
              helperMessage={validateServinceUnits.renderMessage}
            />

          </Form.FormGroup>
          <div>
            <Button
              onClick={handleSubmitServiceUnits}
              disabled={!validateServinceUnits.response.is_passed}
              type="button"
              className="!w-auto !bg-warning !text-black float-right">
              {formDataServiceUnits.id && 'Update'}
              {!formDataServiceUnits.id && 'Add'}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  )
}

// const PropTypesForm = {
//   garage_address: PropTypes.string,
//   garage_dimension: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//   garage_location: PropTypes.string,
//   number_of_units_per_garage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
// }

ExistingFranchiseForm.propTypes = {
  onNext: PropTypes.instanceOf(Function).isRequired,
  onPrevious: PropTypes.instanceOf(Function).isRequired,
}

ExistingFranchiseForm.displayName = 'ExistingFranchiseForm'

export default ExistingFranchiseForm